export const blue = {
  100: "#00CCFF",
  101: "#173753ff",
  102: "#336699",
  200: "#086788ff",
  300: "#2589bdff",
  400: "#6290c8ff",
  500: "#3fa7d6ff",
};

export const green = {
  100: "#529e66",
  200: "#367b48",
  300: "#276738",
};

export const yellow = {
  100: "#e1c542",
  200: "#cab23f",
  300: "#b49e35",
};

export const red = {
  100: "#d0454c",
  200: "#b54248",
  300: "#95353a",
};

export const neutral = {
  100: "#ffffff",
  200: "#f4f5f7",
  300: "#e1e1e1",
  400: "#737581",
  500: "#4a4b53",
  600: "#000000",
};

export const greys = {
  100: "#BCBCBC",
  200: "#707070",
  300: "#4B4b4b",
};

export const textColor = {
  100: "#333333",
};

export const boxShadow = `0px 1px 12px rgba(0, 0, 0, 0.5)`;
